// extracted by mini-css-extract-plugin
module.exports = {"custom_select":"Select_custom_select__e2az4","custom_select_arrow":"Select_custom_select_arrow__3g7Or","custom_select_dropdown":"Select_custom_select_dropdown__3yzYe"};